<span class="text-with-default-missing-value text-area-static"
      [ngClass]="{missing: !this.hasValue}">
  {{this.renderedValue || this.missingValue}}
</span>
